export default {"src":"/_next/static/media/cricket-pitch.b6a7a9e3.svg","height":106,"width":936,"blurWidth":0,"blurHeight":0};